import Entity from "./entity";
import Member from "./member";
import ActionCheckpoint from "./actionCheckpoint";

export default class Objective extends Entity<string> {
  name: string;
  startDate: string;
  endDate: string;
  ownerId: number;
  owner: Member;
  priority: number;
  targetType: number;
  trackingQuestion: string;
  measurementUnit: string;
  inputOptions: string;
  trackingTarget: number;
  checkinDates: string;
  attachments: string;
  description: string;
  trackingResult: number;
  teamTrackingResult: number;
  checkpoints: [ActionCheckpoint];
  historicalCheckpoints: { id: string; trackingDateString: string; result: number; targetUserId: number; targetUserName: any; trackerId: number; trackerName: any }[];
  matchedCheckpoints: { id: string; trackingDateString: string; result: number; targetUserId: number; targetUserName: any; trackerId: number; trackerName: any }[];
  matchedTeamCheckpoints: { id: string; trackingDateString: string; result: number; targetUserId: number; targetUserName: any }[];
  selfAverageResult: number;
  otherAverageResult: number;
  averageResult: number;
  userTrackingResults: number[];
  goalId: string;
}
